import { API_WALLET_URL, URL_ME } from 'config'
import { apiCall } from './base'

export interface TermsAccepted {
  result: Result[]
}
export interface Result {
  wallet_user_uuid: string
  product: string
  identifier: string
  accepted_at: string
  status: boolean
  created_at: string
  updated_at: string
}
interface AdvanceTerms {
  identifier: string
}
export const acceptAdvanceTerms = (data: AdvanceTerms) =>
  apiCall(`${URL_ME}/api/v1/me/loan/terms/ADELANTO`, {
    baseURL: API_WALLET_URL,
    method: 'POST',
    withCredentials: false,
    immediately: true,
    data
  })
export const getTermsAccepted = () =>
  apiCall(`${URL_ME}/api/v1/me/products/terms`, {
    baseURL: API_WALLET_URL,
    method: 'GET',
    withCredentials: false,
    immediately: true
  }).then((res) => res)
